import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';

const routes: Routes = [
  { path: '', redirectTo: environment.caminho_pagina_inicial, pathMatch: 'full' },
  { path: 'login', redirectTo: '/seguranca/login', pathMatch: 'full' },
  { path: 'dashboards', loadChildren: () => import('./dashboards/dashboards.module').then(m => m.DashboardsModule) },
  { path: 'farmacia', loadChildren: () => import('./farmacia/farmacia.module').then(m => m.FarmaciaModule) },
  { path: 'seguranca', loadChildren: () => import('./seguranca/seguranca.module').then(m => m.SegurancaModule) },
  { path: 'homecare', loadChildren: () => import('./homecare/homecare.module').then(m => m.HomecareModule) },
  { path: 'questionario', loadChildren: () => import('./questionario/questionario.module').then(m => m.QuestionarioModule) },
  { path: 'sala-de-medicacao', loadChildren: () => import('./sala-de-medicacao/sala-de-medicacao.module').then(m => m.SalaDeMedicacaoModule) },
  { path: 'coleta', loadChildren: () => import('./coleta/coleta.module').then(m => m.ColetaModule)},
  { path: 'mapa', loadChildren: () => import('./mapa/mapa.module').then(m => m.MapaModule)},
  { path: '**', redirectTo: '/seguranca/pagina-nao-encontrada', pathMatch: 'full' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes
      , { enableTracing: false }
    )
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {}
